import { gql } from '@apollo/client';
import { Prescription } from '@interfaces';

export const lookForPrescriptions = () => gql`
  query LookForPrescription {
    lookForPrescriptions {
      prescriptionRequired
      associations {
        orderDetail {
          id
          product {
            id
            prescriptionType
          }
          quantity
        }
        prescriptionId
        prescription {
          id
          url
        }
      }
    }
  }
`;

export interface LookForPrescriptionsResponse {
  lookForPrescriptions: {
    prescriptionRequired: boolean;
    associations: {
      prescriptionId: string;
      prescription: Pick<Prescription, 'id' | 'url'>;
      orderDetail: {
        id: string;
        quantity: number;
        product: {
          id: string;
        };
      };
    }[];
  };
}
